import { context } from '../../layers/context/index.js';
import timeSpent from '../../layers/time-spent/index.js';
import '../../layers/index.js';

var index = {
  required_layers: [context, timeSpent],
  type: 'web_time_spent'
};

export default index;
